import type { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
};
const JobTitle: FC<Props> = (props) => {
  const { children } = props;

  return <div className="jobTitle">{children}</div>;
};

export default JobTitle;
